import React, { useState } from 'react';
import { Form } from '../components';
import { HeaderContainer } from '../containers/header';
import * as ROUTES from '../constants/routes';

const API_URL = process.env.API_URL || 'https://vieon-api.lumination.vn';

export default function SignIn() {
  const [emailAddress, setEmailAddress] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const isInvalid = password === '' || emailAddress === '';

  const handleSignin = async (event) => {
    event.preventDefault();
    setError('');
    setIsLoading(true);

    try {
      console.log('🔐 Calling login API...');

      const response = await fetch(`${API_URL}/api/auth/login`, {
        method: 'POST',
        headers: {
          accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: emailAddress,
          password,
        }),
      });

      const data = await response.json();
      console.log('� API Response:', data);

      if (!response.ok) {
        throw new Error(data.message || 'Đăng nhập thất bại');
      }

      if (data.success && data.profiles) {
        // Store authenticated user with profiles and user info.
        // sessionVersion is used to support force-logout from all devices:
        // it is revalidated against the server periodically.
        const authData = {
          email: data.user.email,
          userId: data.user.id,
          sessionVersion: data.user.sessionVersion ?? 0,
          profiles: data.profiles,
        };

        console.log('💾 Storing authUser:', authData);
        localStorage.setItem('authUser', JSON.stringify(authData));
        console.log('✅ Login successful, redirecting to home...');

        window.location.href = ROUTES.HOME;
      } else {
        throw new Error('Dữ liệu phản hồi không hợp lệ');
      }
    } catch (err) {
      console.error('❌ Login error:', err);
      setError(err.message || 'Email hoặc mật khẩu không đúng');
      setEmailAddress('');
      setPassword('');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <HeaderContainer
        showSignInButton={false}
        headerStyle={{ minHeight: '100vh' }}
      >
        <div
          style={{
            minHeight: 'calc(100vh - 200px)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            padding: '24px',
            boxSizing: 'border-box',
          }}
        >
          <Form style={{ margin: 0, marginBottom: 0 }}>
            <Form.Title>Đăng Nhập</Form.Title>
            {error && <Form.Error data-testid="error">{error}</Form.Error>}

            <Form.Base onSubmit={handleSignin} method="POST">
              <Form.Input
                placeholder="Email"
                value={emailAddress}
                onChange={({ target }) => setEmailAddress(target.value)}
                disabled={isLoading}
              />
                <Form.Input
                  type="password"
                  value={password}
                  autoComplete="off"
                  placeholder="Mật khẩu"
                  onChange={({ target }) => setPassword(target.value)}
                  disabled={isLoading}
                />
              <Form.Submit disabled={isInvalid || isLoading} type="submit" data-testid="sign-in">
                {isLoading ? 'Đang đăng nhập...' : 'Đăng Nhập'}
              </Form.Submit>
            </Form.Base>
          </Form>
        </div>
      </HeaderContainer>
    </>
  );
}
